/**
 * Brand color constants for JS contexts that cannot consume CSS variables
 * (Chart.js dataset colors, canvas operations, etc.)
 * These values MUST stay in sync with the CSS custom properties in GlobalStyles.tsx.
 * All other code should use var(--token) instead.
 */

export const BRAND_INK        = '#090F38';  // --brand-ink
export const BRAND_INK_2      = '#141B4E';  // --brand-ink-2
export const BRAND_GREEN      = '#76B159';  // --brand-green / --chart-1
export const BRAND_GREEN_SOFT = '#EDF5E4';  // --brand-green-soft
export const BRAND_LIME       = '#C5E861';  // --brand-lime
export const BRAND_YELLOW     = '#FBB03B';  // --brand-yellow / --chart-3
export const BRAND_GRAY       = '#CBCACA';  // --brand-gray

export const DANGER           = '#D47974';  // --danger / --chart-5
export const WARNING          = '#DA9213';  // --warning
export const INFO             = '#4A78D6';  // --info / --chart-2
export const MUTED            = '#6E72A0';  // --muted / --chart-8

// Plain white/black for JS contexts (tooltips, canvas, chart borders)
export const WHITE = '#FFFFFF';
export const BLACK = '#000000';

// Chart palette — use in order (matches --chart-1 … --chart-8)
export const CHART_COLORS = [
  '#76B159',  // --chart-1  green
  '#4A78D6',  // --chart-2  blue
  '#FBB03B',  // --chart-3  yellow
  '#8B5CD6',  // --chart-4  violet
  '#D47974',  // --chart-5  coral
  '#2BA3A8',  // --chart-6  teal
  '#BB6A2E',  // --chart-7  burnt orange
  '#6E72A0',  // --chart-8  muted
] as const;

// Avatar placeholder color palette — hashed by name
export const AVATAR_PALETTES: Array<{ bg: string; color: string }> = [
  { bg: '#E8F4FE', color: '#1A5FA8' },
  { bg: '#FEF3E8', color: '#B85C0A' },
  { bg: '#E8FEF0', color: '#166A38' },
  { bg: '#F8E8FE', color: '#7A0ABB' },
  { bg: '#FEE8E8', color: '#A80A0A' },
  { bg: '#E8FEFE', color: '#0A7E7E' },
  { bg: '#F0F8FE', color: '#1A5F8A' },
  { bg: '#FEFAE8', color: '#8A700A' },
];

// Customer tag color palette — hashed by name
export const CUSTOMER_PALETTES: Array<{ bg: string; color: string }> = [
  { bg: '#FFF4E6', color: '#C05621' },
  { bg: '#F0FDF4', color: '#166534' },
  { bg: '#EEF2FF', color: '#3730A3' },
  { bg: '#FDF2F8', color: '#9D174D' },
  { bg: '#ECFEFF', color: '#155E75' },
  { bg: '#FFFBEB', color: '#92400E' },
  { bg: '#F5F3FF', color: '#5B21B6' },
  { bg: '#FFF1F2', color: '#9F1239' },
];

// Order detail product thumbnail background palette
export const THUMB_COLORS = ['#FFE5EC', '#E1F0FF', '#E6F5E1', '#FFF4E1', '#F0E5FF', '#E1FAF5'] as const;

// Marketplace platform card background palette
export const MARKETPLACE_BG_COLORS = [
  '#FFFBEE', '#EEF3FB', '#F3EEF8', '#F0F4FF', '#EEFBEE',
  '#F2F5FF', '#EEF9FB', '#F5F0FF', '#F5F2EC',
] as const;

// Semantic extras for JS contexts
export const COLOR_DELIVERED = '#27AE60';   // success-adjacent (delivered orders)
export const COLOR_FAILED    = '#EB5757';   // danger-adjacent (failed orders)
export const COLOR_RETURNED  = '#F2994A';   // warning-adjacent (returned orders)
export const WHATSAPP_GREEN  = '#25D366';   // WhatsApp brand color
